import { ReportConfiguration } from "../../../configuration"
import { DocumentSection } from "../../types";
import { formatTitle } from "../../utils";
import PptxGenJS, { Slide } from "pptxgenjs"
import { MasterSlide } from "../../pptx-configuration/master-slides";
import { Placeholder } from "../../pptx-configuration/placeholders";
import { LocalAuthority } from "../../../../../model";
import * as SynthesisDomain from "../../../../../domain/sfp/synthesis-domain"



export function checkSynthesisSection(
	configuration: ReportConfiguration
): boolean {
	const synthesis = configuration.observation.synthesis;
	return synthesis.synthesis;
}

export function createSynthesisSection(
    pptx: PptxGenJS,
	configuration: ReportConfiguration,
    numbering:number[],
    localAuthority:LocalAuthority
): DocumentSection{	
    const title = formatTitle("Comparaisons", numbering);
	const slides: Slide[] = [];
    const synthesis = configuration.observation.synthesis;
	const currentYear = configuration.generalities.referenceYear;

    if(synthesis){
        let values:SynthesisValues = SynthesisDomain.getSynthesisValues(localAuthority,currentYear);

        const slide = pptx.addNewSlide("BLANK")
        slide.addText("", { placeholder: Placeholder.Title })
        //Partie Gauche de la slide
        slide.addShape(pptx.shapes.RECTANGLE, { x: 0, y: 0, w:4,h:7.5,fill:"3DC4AC"});
        slide.addText("Compte Administratif " + currentYear + " Prévisionnel",{x:0.25, y:4,w:3,color:"FFFFFF"})
        slide.addText("Synthèse des résultats",{x:0.25, y:5,w:3, underline:true,color:"FFFFFF"})

        //#region Resultat prévisionnel section fonctionnement 
        const Y_OFFSET_FCT = 0.3

            //#region Texte Titre section
            slide.addText("Résultat Prévisionnel section fonctionnement",{underline:true,x:4.5,y:Y_OFFSET_FCT})
            //#endregion

            //LIGNE 1
            const Y_OFFSET_LINE_ONE = Y_OFFSET_FCT + 0.5;
            //#region ShapesLineOne
            //Cases Recettes/Depenses/Résultat
            slide.addShape(pptx.shapes.RECTANGLE, { x: 4.5, y: Y_OFFSET_LINE_ONE, w:2,h:0.75,fill:"3DC4AC", rectRadius:5});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 7.5 ,y: Y_OFFSET_LINE_ONE, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 10.5, y: Y_OFFSET_LINE_ONE, w:2,h:0.75,fill:"3DC4AC"});
            
            //Moins
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.75, y: Y_OFFSET_LINE_ONE + 0.275, w:0.5,h:0.2,fill:"3DC4AC"});
            //Egal
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_ONE + 0.15, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_ONE + 0.40, w:0.4,h:0.15,fill:"3DC4AC"});
            //#endregion
            
            //#region TextLineOne
            slide.addText("Recettes",{x:4.5,y:Y_OFFSET_LINE_ONE,color:"FFFFFF"})
            slide.addText( values.recetteFct.toLocaleString('fr') + " €",{x:4.5,y:Y_OFFSET_LINE_ONE+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Depenses",{x:7.5,y:Y_OFFSET_LINE_ONE,color:"FFFFFF"})
            slide.addText( values.depensesFct.toLocaleString('fr') + " €",{x:7.5,y:Y_OFFSET_LINE_ONE+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat",{x:10.5,y:Y_OFFSET_LINE_ONE,color:"FFFFFF"})
            slide.addText( values.resultatFct.toLocaleString('fr') + " €",{x:10.5,y:Y_OFFSET_LINE_ONE+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            //#endregion

            //LIGNE 2
            const Y_OFFSET_LINE_TWO = Y_OFFSET_FCT + 1.5;
            //#region ShapesLineTwo
            //Cases Recettes/Depenses/Résultat
            slide.addShape(pptx.shapes.RECTANGLE, { x: 4.5, y: Y_OFFSET_LINE_TWO, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 7.5 ,y: Y_OFFSET_LINE_TWO, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 10.5, y: Y_OFFSET_LINE_TWO, w:2,h:1.25,fill:"3D99C4"});

            //Plus
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_TWO + 0.275, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_TWO + 0.275, w:0.4,h:0.15,fill:"3DC4AC" , rotate:90});
            //Egal
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_TWO + 0.15, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_TWO + 0.40, w:0.4,h:0.15,fill:"3DC4AC"});
            //#endregion

            //#region TextLineTwo
            slide.addText("Résultat",{x:4.5,y:Y_OFFSET_LINE_TWO,color:"FFFFFF"})
            slide.addText( values.resultatFct.toLocaleString('fr') + " €",{x:4.5,y:Y_OFFSET_LINE_TWO+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Report N-1",{x:7.5,y:Y_OFFSET_LINE_TWO,color:"FFFFFF"})
            slide.addText( values.reportNm1Fct.toLocaleString('fr') + " €",{x:7.5,y:Y_OFFSET_LINE_TWO+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat section fonctionnement",{x:10.5,y:Y_OFFSET_LINE_TWO+0.15,color:"FFFFFF",w:3})
            slide.addText( values.resSectFct.toLocaleString('fr') + " €",{x:10.5,y:Y_OFFSET_LINE_TWO+0.65,color:"FFFFFF",w:2,align:"center",bold:true})
            //#endregion
        //#endregion

        //#region Resultat prévisionnel section invest 
        const Y_OFFSET_INV = 3.1

            //#region Texte Titre section
            slide.addText("Résultat Prévisionnel section investissement",{underline:true,x:4.5,y:Y_OFFSET_INV})
            //#endregion

            //LIGNE 1
            const Y_OFFSET_LINE_ONE_I = Y_OFFSET_INV + 0.5;
            //#region ShapesLineOne
            //Cases Recettes/Depenses/Résultat
            slide.addShape(pptx.shapes.RECTANGLE, { x: 4.5, y: Y_OFFSET_LINE_ONE_I, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 7.5 ,y: Y_OFFSET_LINE_ONE_I, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 10.5, y: Y_OFFSET_LINE_ONE_I, w:2,h:0.75,fill:"3DC4AC"});
            
            //Moins
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.75, y: Y_OFFSET_LINE_ONE_I + 0.275, w:0.5,h:0.2,fill:"3DC4AC"});
            //Egal
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_ONE_I + 0.15, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_ONE_I + 0.40, w:0.4,h:0.15,fill:"3DC4AC"});
            //#endregion

            //#region TextLineOne
            slide.addText("Recettes",{x:4.5,y:Y_OFFSET_LINE_ONE_I,color:"FFFFFF"})
            slide.addText( values.recetteInv.toLocaleString('fr') + " €",{x:4.5,y:Y_OFFSET_LINE_ONE_I+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Depenses",{x:7.5,y:Y_OFFSET_LINE_ONE_I,color:"FFFFFF"})
            slide.addText( values.depensesInv.toLocaleString('fr') + " €",{x:7.5,y:Y_OFFSET_LINE_ONE_I+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat",{x:10.5,y:Y_OFFSET_LINE_ONE_I,color:"FFFFFF"})
            slide.addText( values.resultatInv.toLocaleString('fr') + " €",{x:10.5,y:Y_OFFSET_LINE_ONE_I+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            //#endregion
            
            //LIGNE 2
            const Y_OFFSET_LINE_TWO_I = Y_OFFSET_INV + 1.5;
            //#region ShapesLineTwo
            //Cases Recettes/Depenses/Résultat
            slide.addShape(pptx.shapes.RECTANGLE, { x: 4.5, y: Y_OFFSET_LINE_TWO_I, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 7.5 ,y: Y_OFFSET_LINE_TWO_I, w:2,h:0.75,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 10.5, y: Y_OFFSET_LINE_TWO_I, w:2,h:1.25,fill:"3D99C4"});

            //Plus
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_TWO_I + 0.275, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_TWO_I + 0.275, w:0.4,h:0.15,fill:"3DC4AC" , rotate:90});
            //Egal
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_TWO_I + 0.15, w:0.4,h:0.15,fill:"3DC4AC"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_TWO_I + 0.40, w:0.4,h:0.15,fill:"3DC4AC"});
            //#endregion

            //#region TextLineTwo
            slide.addText("Résultat",{x:4.5,y:Y_OFFSET_LINE_TWO_I,color:"FFFFFF"})
            slide.addText( values.resultatInv.toLocaleString('fr') + " €",{x:4.5,y:Y_OFFSET_LINE_TWO_I+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Report N-1",{x:7.5,y:Y_OFFSET_LINE_TWO_I,color:"FFFFFF"})
            slide.addText( values.reportNm1Inv.toLocaleString('fr') + " €",{x:7.5,y:Y_OFFSET_LINE_TWO_I+0.3,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat section investissement",{x:10.5,y:Y_OFFSET_LINE_TWO_I+0.15,color:"FFFFFF",w:3})
            slide.addText( values.resSectInv.toLocaleString('fr') + " €",{x:10.5,y:Y_OFFSET_LINE_TWO_I+0.65,color:"FFFFFF",w:2,align:"center",bold:true})
            //#endregion
        //#endregion

        //#region Resultat prévisionnel global
        const Y_OFFSET_G = 4.5          
            const Y_OFFSET_LINE_G = Y_OFFSET_G + 1.5;
            //#region Texte Titre section
            slide.addText("Résultat Prévisionnel global",{underline:true,x:4.5,y:Y_OFFSET_G+1})
            //#endregion

            //#region ShapesLineTwo
            //Cases Recettes/Depenses/Résultat
            slide.addShape(pptx.shapes.RECTANGLE, { x: 4.5, y: Y_OFFSET_LINE_G, w:2,h:1.25,fill:"3D99C4"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 7.5 ,y: Y_OFFSET_LINE_G, w:2,h:1.25,fill:"3D99C4"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 10.5, y: Y_OFFSET_LINE_G, w:2,h:1.25,fill:"3D99C4"});

            //Plus
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_G + 0.375, w:0.4,h:0.15,fill:"3D99C4"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 6.8, y: Y_OFFSET_LINE_G + 0.375, w:0.4,h:0.15,fill:"3D99C4" , rotate:90});
            //Egal
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_G + 0.25, w:0.4,h:0.15,fill:"3D99C4"});
            slide.addShape(pptx.shapes.RECTANGLE, { x: 9.8, y: Y_OFFSET_LINE_G + 0.50, w:0.4,h:0.15,fill:"3D99C4"});
            //#endregion

            //#region TextLineTwo
            slide.addText("Résultat section fonctionnement",{x:4.5,y:Y_OFFSET_LINE_G+0.15,color:"FFFFFF" ,w:3})
            slide.addText( values.resSectFct.toLocaleString('fr') + " €",{x:4.5,y:Y_OFFSET_LINE_G+0.65,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat section investissement",{x:7.5,y:Y_OFFSET_LINE_G+0.15,color:"FFFFFF" ,w:3})
            slide.addText( values.resSectInv.toLocaleString('fr') + " €",{x:7.5,y:Y_OFFSET_LINE_G+0.65,color:"FFFFFF",w:2,align:"center",bold:true})
            slide.addText("Résultat global",{x:10.5,y:Y_OFFSET_LINE_G+0.15,color:"FFFFFF",w:3})
            slide.addText( values.resGlobal.toLocaleString('fr') + " €",{x:10.5,y:Y_OFFSET_LINE_G+0.65,color:"FFFFFF",w:2,align:"center",bold:true})
            //#endregion
        //#endregion
        
        
        slides.push(slide);
	}

    return { title, slides }
}

export class SynthesisValues{
    recetteFct:number = 0;
    resultatFct:number = 0;
    depensesFct:number = 0;
    reportNm1Fct:number = 0;
    resSectFct:number = 0;
    recetteInv:number = 0;
    depensesInv:number = 0;
    resultatInv:number = 0;
    reportNm1Inv:number = 0;
    resSectInv:number = 0;
    resGlobal:number = 0;
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/synthesis-generator/synthesis-generator.tsx